import { getValueByPath } from './objectUtil'

function PrefixInteger(num, length = 2) {
  return (Array(length).join('0') + num).slice(-length)
}
/***
 * 返回字符串的ASCII码长度（单个字符大于255视为1否则视为0.5）
 * text: string 需要计算的字符串
 * lengths: array 字符串长度判定级别
 * widths: array 字符宽度设置级别
 *
 */
export function textWidth(text, lengths, widths) {
  const wid = !text
    ? 0
    : text.split('').reduce((pre, cur) => {
        if (cur.charCodeAt(0) > 255) {
          return pre + 1
        } else {
          return pre + 0.5
        }
      }, 0)

  if (!lengths?.length || !widths.length || lengths.length !== widths.length) {
    return 18
  }
  const lengthsIndex = lengths.findIndex((len) => len >= wid)
  return lengthsIndex !== -1 ? widths[lengthsIndex] : widths[widths.length - 1]
}

export function hexText(str) {
  return str
}

export function escapeZebra(str) {
  return str
}

export function escapeSato(str) {
  return str
}

export function escapePostek(str) {
  return str
}

export function getItem(path, method = 'local') {
  if (!path) return {}

  const storageMethod = `${method}Storage`
  try {
    return JSON.parse(window[storageMethod].getItem(path))
  } catch (error) {
    console.error(error.message)
    return {}
  }
}

export function setItemsChecked(source, target, path = 'id') {
  const sourceMap = new Map()

  source.forEach((s) => {
    sourceMap.set(getValueByPath(s, path), true)
  })

  return target.map((t) => ({
    ...t,
    checked: sourceMap.get(getValueByPath(t, path)) || false,
  }))
}

// 获取员工菜单授权(集团)-复制权限-选择待授权员工的 ids
export function getTargetIdsTrust(formData, covert = true, checked = true) {
  const result = { ...formData }
  const arr = formData.targets || []
  const selected = []
  const childrens = []

  for (const row of arr) {
    childrens.push(...[...row.children])
  }
  for (const child of childrens) {
    if (checked) {
      // 只返回已选中的
      if (child.checked && child.id) selected.push(child.id)
    } else {
      // 返回全部（id 存在的）
      if (child.id) selected.push(child.id)
    }
  }

  result.source = formData.source
  result.targetIds = selected
  if (covert) {
    result.targetIds = selected.join(',')
  }
  return result
}

// 获取员工菜单授权-复制权限-选择待授权员工的 ids
export function getTargetIds(formData, covert = true, checked = true) {
  const result = {}
  const arr = formData.targets || []
  const selected = []
  const childrens = []

  for (const row of arr) {
    childrens.push(...[...row.children])
  }
  for (const child of childrens) {
    if (checked) {
      // 只返回已选中的
      if (child.checked && child.id) selected.push(child.id)
    } else {
      // 返回全部（id 存在的）
      if (child.id) selected.push(child.id)
    }
  }

  result.source = formData.source
  result.targetIds = selected
  if (covert) {
    result.targetIds = selected.join(',')
  }
  return result
}

// 获取当月第一天的 Date
export function getNowMonthFirst() {
  const now = new Date()
  const one = `${now.getFullYear()}-${PrefixInteger(now.getMonth() + 1)}-01`
  return new Date(one)
}

//获取当月第一天至当天的日期段
export function getNowMonthRang() {
  const now = new Date()
  const one = `${now.getFullYear()}-${PrefixInteger(now.getMonth() + 1)}-01 00:00:00`
  let two = `${now.getFullYear()}-${PrefixInteger(now.getMonth() + 1)}-${PrefixInteger(
    now.getDate()
  )} 23:59:59`
  return [one, two]
}

/**
 * 判断是否禁止勾选(适用于系统 LINK)
 * 适用范围：#9718 加工-来自补货申请单
 * @param {*} selections 已选中的库存数据
 * @param {*} rowData 当前行库存数据，例如: { row: { ... } }
 * @param {*} templateData 当前模板数据
 * @returns
 */
export function checkedByInventoryForLink(selections, rowData, templateData) {
  const { row } = rowData
  const { goodsItems } = templateData
  if (selections.length === 0) return true // 没有选中数据时，不禁止勾选

  const amountMap = new Map()
  goodsItems.forEach((item) => {
    if (item.goodsInfo?.id) amountMap.set(item.goodsInfo.id, item.amount)
  })

  const available = selections.reduce((prev, item) => {
    if (row.goodsDetail.id === item.goodsDetail.id) {
      return prev + item.available
    }
    return prev
  }, 0)

  const _amount = amountMap.get(row.goodsDetail.id) || 0
  if (!_amount) return true // 没有找到商品详情时，不禁止勾选
  const amount = templateData.amount * _amount

  // 如果已勾选，则不禁止勾选
  return row.checked || available < amount
}

/**
 * 转换传给打印模板的数据
 * 适用范围：#9718 加工-来自补货申请单
 * @param {*} templateData 模板数据
 * @param {*} path 订单数据路径，默认：'' - 可配置为 'otherInfo.order'
 * @returns
 */
export function transformPrintData(templateData, path = '') {
  if (!templateData?.length) return [] // 没有数据时，不转换
  return templateData.map((item) => {
    const orderData = path ? getValueByPath(item, path) : item
    const { packageTemplate, virtualWarehouse, id } = orderData || {}
    //增加id 让打印模板能取到单据id
    return {
      id,
      code: item.code, // EPC
      packageTemplate,
      virtualWarehouse,
    }
  })
}
